<template>
  <!-- Shop Tab Section -->
  <section v-if="shopifyData.checkSection == 'false'" class="shop_tabs_sec">
    <div class="container">
      <!-- Tabs Header on Scroll -->
      <div class="nanamota_tabs_header-main">
        <div class="inner_tab_header">
          <ul class="nanamota_tabs_header">
            <!-- nanamota logo -->
            <li class="nanamota_logo d-block">
              <img
                v-lazy="shopifyData.headerlogo.src"
                :src-placeholder="shopifyData.headerlogo.placeholder"
                :alt="shopifyData.headerlogo.alt || 'Logo Image'"
                loading="lazy"
                aria-hidden="true"
                aria-label="Logo Image"
                width=""
                height=""
              />
            </li>
            <!-- Tabs Tittles Button  -->
            <li class="d-block">
              <ul class="shop_tab_list">
                <li
                  v-for="(item, index) in shopifyData.tabsItemsNannamota.slice(3, 6)"
                  :key="index"
                  class="tab_btn"
                >
                  <a class="tab_title" v-html="item.tabsItems" />
                </li>
              </ul>
            </li>
            <li class="d-block back_to_behno_btn">
              <a
                :href="shopifyData.NanaMotaHeaderBackToLink"
                v-html="shopifyData.NanaMotaHeaderBackTo"
              />
            </li>
          </ul>
        </div>
      </div>

      <!-- Tabs Body -->

      <div class="tabs_body testing">
        <div v-for="(value, key) in productLists" :key="key" class="tabs_contents_grid">
          <!-- Image Of Product -->
          <div
            v-for="(ChildVal, ChildKey) in value.product.slice(0, 3)"
            :key="ChildKey"
            class="tabs_img"
          >
            <a class="tabs_contents_link d-block" :href="`/products/` + ChildVal.handle">
              <img
                v-lazy="ChildVal.images[0]"
                class="d-block"
                :alt="ChildVal.images[0].alt || 'Product Image'"
                loading="lazy"
                aria-hidden="true"
                aria-label="Product Image"
                width=""
                height=""
              />
              <div class="content_detail">
                <strong>
                  <p class="content_name" v-html="captilizeTitle(ChildVal.title)" />
                </strong>
                <strong>
                  <p class="content_type" v-html="ChildVal.name" />
                </strong>
                <strong>
                  <p class="content_cost">${{ (ChildVal.price / 100).toFixed(2) }}</p>
                </strong>
              </div>
            </a>
          </div>
        </div>
      </div>
      <div class="cta_wrapper">
        <a
          class="shop_btn d-block"
          :href="shopifyData.secCtaLink"
          v-html="shopifyData.secCtaText"
        />
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    shopifyData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      productLists: [],
      sEvent: this.scrollEvents(),
      tabs: this.shopifyData.tabsItemsNannamota,
      path: window.location.hostname,
    };
  },
  mounted() {
    this.productsList();
  },

  methods: {
    //===================================================//
    // captilize title
    //===================================================//

    captilizeTitle(str) {
      const arr = str.split(' ');

      for (let i = 0; i < arr.length; i++) {
        arr[i] = arr[i].toLowerCase(); ///+ arr[i].slice(1);
      }

      const str2 = arr.join(' ');
      return str2;
    },
    /**
     * Scroll events
     */

    scrollEvents() {
      const curobj = this;
      // // Tab sticky Header
      (window.addEventListener('load', () => {
        const ancherList = document.querySelectorAll('.shop_tab_list a');
        document.querySelector('.shop_tab_list a').classList.add('active');
        const TabSConten = document.querySelectorAll('.tabs_contents_grid');
        document.querySelector('.tabs_contents_grid').classList.add('active');
        ancherList.forEach((element, index) => {
          element.addEventListener('click', () => {
            document.querySelector('.shop_tab_list a.active').classList.remove('active');
            document.querySelector('.tabs_contents_grid.active').classList.remove('active');
            element.classList.add('active');
            TabSConten[index].classList.add('active');
          });
        });
      }),
        window.addEventListener('scroll', () => {
          const tabheader = document.querySelector('.shop_tabs_sec');
          const tabInnerheader = document.querySelector('.inner_tab_header');
          const maintabheader = document.querySelector('.nanamota_tabs_header-main');
          const getHeight = tabInnerheader.clientHeight;
          const ancherList = document.querySelectorAll('.shop_tab_list a');
          // let araay =["/collections/nanamota-womens","/collections/nanamota-mens","/collections/nanamota-facemasks"]

          const araay = [];
          for (const tab of curobj.tabs) {
            if (tab.tabitemLink != '') {
              araay.push(tab.tabitemLink);
            }
          }

          const gettopheader = tabheader.getBoundingClientRect().top;

          if (gettopheader < -20) {
            ancherList.forEach((elemetn, index) => {
              elemetn.setAttribute('href', `${araay[index]}`);
            });
            tabheader.classList.add('active');
            maintabheader.setAttribute('style', `min-height:${getHeight}px`);
          } else {
            tabheader.classList.remove('active');
            maintabheader.removeAttribute('style');
            for (const i of ancherList) {
              i.removeAttribute('href');
            }
          }
        }));
    },

    /**
     * Get Product List by collection
     */
    productsList() {
      const pList = JSON.parse(window.atob(this.shopifyData.products));

      this.productLists = [...pList].slice(0, 3);
    },
  },
};
</script>
<style scoped>
/*======= CSS=======*/
.d-block {
  display: block;
}

p {
  font-family: 'Work Sans', sans-serif;
}

/*------- Tabs Tittles Button css -------*/
.shop_tabs_sec {
  padding-block: 15px 45px;
}

.container {
  max-width: 1460px;
  width: 100%;
  padding-inline: 20px;
  margin: 0 auto;
}

/*------- Tabs Header on Scroll -------*/
.nanamota_tabs_header {
  display: grid;
  grid-template-columns: 220px 600px 220px;
  justify-content: space-between;
  align-items: center;
  max-width: 1420px;
  margin: 0 auto;
  width: 100%;
}

.nanamota_tabs_header > li:last-child {
  text-align: end;
  font-size: 14px;
  padding: 10px 20px;
}

.shop_tab_list {
  display: flex;
  max-width: 600px;
  justify-content: space-between;
  margin: 0 auto;
  transition: 0.5s;
  animation: nanamotatabsremove 0.4s linear;
}

@keyframes nanamotatabsremove {
  0% {
    transform: translateX(-50%);
  }

  100% {
    transform: translateX(0px);
  }
}

.nanamota_logo {
  margin-left: 20px;
}

.tab_btn {
  cursor: pointer;
  padding: 10px 15px;
  max-width: 202px;
  width: 100%;
  text-align: center;
}

.tab_title {
  font-family: 'Work Sans', sans-serif;
  font-size: 18px;
  font-weight: normal;
  width: auto;
  text-align: center;
  color: #7d8d8d;
}

.shop_tabs_sec.active .tab_title {
  color: #fff;
}

.tab_title.active {
  border-bottom: 2px solid #000;
  color: #000;
}

/*------- Tabs body css -------*/
.tabs_body {
  margin-top: 75px;
}

.tabs_contents_grid {
  display: none;
  grid-template-columns: repeat(3, 1fr);
  justify-content: space-between;
  gap: 30px;
}

.tabs_contents_grid.active {
  display: grid;
}

/*-- Image of Product --*/
.tabs_img {
  position: relative;
  width: fit-content;
  margin: 0 auto;
}

/*-- Content Detail Of Product On Image --*/
.content_detail {
  position: absolute;
  left: 5px;
  bottom: 5px;
}

/* .content_detail p {
  line-height: 9px;
  letter-spacing: -0.08px;
} */
.content_name {
  /* font-weight: 700; */
  font-size: 13.4px;
  line-height: 1;
  text-transform: capitalize;
}

.content_type,
.content_cost {
  font-size: 12px;
  margin-top: 10px;
  font-weight: normal;
}

.shop_btn {
  margin: 100px auto 0;
  padding: 10px 20px;
  background-color: #f0ded0;
  border-radius: 30px;
  text-align: center;
  width: fit-content;
}

.shop_btn:hover {
  background-color: #efd4bf !important;
}

.shop_btn,
.shop_btn a {
  font-family: 'Work Sans', sans-serif;
  font-size: 17px;
  font-weight: 300;
  letter-spacing: 1px;
}

.inner_tab_header {
  transition: 0.5s;
  padding: 30px 0 15px;
  background: transparent;
}

.shop_tabs_sec.active .inner_tab_header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 4;
  background: #000;
}

.back_to_behno_btn,
.nanamota_logo {
  opacity: 0;
  transition: 0.5s;
}

.back_to_behno_btn a {
  color: #ffff;
}

.shop_tabs_sec.active .nanamota_logo,
.shop_tabs_sec.active .back_to_behno_btn {
  opacity: 1;
}

.shop_tabs_sec.active .shop_tab_list {
  animation: nanamotatabs 0.4s linear;
  transition: 0.5s;
}

@keyframes nanamotatabs {
  0% {
    transform: translateX(50%);
  }

  100% {
    transform: translateX(0px);
  }
}

/*=== Breakpoint At 991px ===*/

@media only screen and (max-width: 991px) {
  .tabs_contents_grid {
    grid-template-columns: 1fr;
    justify-content: center;
    max-width: 600px;
    margin: 0 auto;
  }

  .shop_btn a {
    font-size: 13px;
  }

  /*------- Tabs Header on Scroll -------*/
  .nanamota_tabs_header > li:last-child,
  .nanamota_logo {
    display: none;
  }

  .nanamota_tabs_header {
    grid-template-columns: 1fr;
  }

  .tab_title {
    font-size: 16px;
  }

  .shop_tab_list {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
  }

  .inner_tab_header {
    padding: 2px 0;
  }

  .tab_btn {
    text-align: center;
  }
}

/*=== Breakpoint At 767px ===*/
@media only screen and (max-width: 767px) {
  /*------- Tabs body css -------*/
  .tabs_body {
    margin-top: 60px;
  }
}

/*=== Breakpoint At 575px ===*/
@media only screen and (max-width: 575px) {
  .tab_btn {
    padding: 10px 5px;
  }
}
</style>
